import { Category } from '@/rule/domain/Category.ts';

export class Categories {
  readonly #map: Map<string, Category>;

  private constructor(list: Map<string, Category>) {
    this.#map = list;
  }

  static of(...list: (Category | string)[]): Categories {
    return new Categories(
      new Map(
        list.map((item) => {
          const category = Category.of(item);
          return [category.value, category] as const;
        }),
      ),
    );
  }

  remove(...list: (Category | string)[]): Categories {
    const newList = new Map(this.#map);
    for (const item of list) {
      const category = Category.of(item);
      newList.delete(category.value);
    }
    return new Categories(newList);
  }

  add(...list: Category[]): Categories {
    const newList = new Map(this.#map);
    for (const category of list) {
      newList.set(category.value, category);
    }
    return new Categories(newList);
  }

  has(category: Category) {
    return this.#map.has(category.value);
  }

  get list(): Category[] {
    return [...this.#map.values()];
  }

  isEmpty() {
    return this.#map.size === 0;
  }
}
